import { useCallback } from "react";
import { IPosition } from "@vmosolutions/oc-interfaces";
import { useSelector } from "react-redux";
import { IRootState } from "src/redux/reducers/CombinedReducers";
import { FormikSelectField } from "src/components/FormikComponents/FormikWrappers";
import { ISelectFieldProps } from "src/components/FormikComponents/SelectField";
import { formatFunction, parseFunction } from "./helpers";

interface ICrewPositionSelectFieldProps extends Omit<ISelectFieldProps, "options"> {
  mosaicPane: HTMLElement;
  valueKey?: string; // valueKey sent back as value - use entire object otherwise.
}

/**
 * Sepcialized wrapper for "built-in" oc crew positions select field.
 * @param props -
 */
export const CrewPositionSelectField = (props: ICrewPositionSelectFieldProps): JSX.Element => {
  const { mosaicPane, label, name, onChange, valueKey, isMulti, ...selectProps } = props;

  //const mosaicPane = useMemo(() => {
  //  return id ? document.getElementById(`${id}-panel`) : null;
  //}, [id]);

  ////////////////////////////
  // MANAGE CREW POSITION LIST
  ////////////////////////////
  const positions: IPosition[] = useSelector((state: IRootState) => state.structures.customerStructure.positions).sort(
    (a, b) => (b.displayOrder > a.displayOrder ? -1 : 1)
  );

  // Setup Format And Parse functions (used if valueKey is passed)
  const formatValue = useCallback(
    (value: string) => formatFunction(value, positions, valueKey, isMulti),
    [positions, valueKey, isMulti]
  );
  const parseOption = useCallback((option: string) => parseFunction(option, valueKey, isMulti), [valueKey, isMulti]);

  return (
    <FormikSelectField
      name={name}
      label={label ?? "Crew Positions"}
      isMulti={isMulti}
      options={positions}
      getOptionLabel={(position: IPosition) => position.description}
      getOptionValue={(position: IPosition) => position._id}
      format={(value) => (valueKey ? formatValue(value) : value)}
      parse={(option) => (valueKey ? parseOption(option) : option)}
      onChange={(value: any) => !!onChange && onChange(value)}
      menuPortalTarget={mosaicPane}
      menuPosition={mosaicPane ? "fixed" : undefined}
      placeholder={`Select Crew Position${isMulti && "s"}`}
      isSearchable={true}
      isClearable={true}
      {...selectProps} // override with any props passed in such as isMulti, format, parse.
    />
  );
};
